define('adminWorkActivityDetailPopupView',[
  'app',
  'module',
  'underscore',
  'jquery',
  'marionette',
  'moment',
  'chart',
  'template!adminWorkActivityDetailPopupTpl',
  'entities/admin/work_activity'
], function (
  App,
  Module,
  _,
  $,
  Marionette,
  moment,
  Chart,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'admin-work-activity-detail-popup-view',

    ui: {
      close: '.js-close'
    },

    events: {
      'click @ui.close': 'onClose'
    },

    initialize: function () {
      this.userpidSecId = this.options.userpidSecId;
      this.fullName = this.options.fullName || '';
      this.handle = this.options.handle || '';
      this.initials = this.options.initials || '?';
      this.from = this.options.from;       // moment
      this.to = this.options.to;           // moment
      this.totalMinutesFromList = this.options.totalMinutesFromList || 0;
      this.activeDaysFromList = this.options.activeDaysFromList || 0;

      this.loading = true;
      this.daily = [];
      this.changeGroups = [];
      this.totalMoves = 0;
      this.chart = null;
    },

    serializeData: function () {
      var totalDailyMin = _.reduce(this.daily, function (a, d) {
        return a + (d.totalMinutes || 0);
      }, 0);
      // Fall back to the list's numbers while still loading so the popup is
      // never empty on first paint.
      var totalMinutes = this.loading ? this.totalMinutesFromList : totalDailyMin;
      var totalDays = this.loading ?
        this.activeDaysFromList :
        this.daily.length;

      return {
        fullName: this.fullName || '?',
        handle: this.handle,
        initials: this.initials,
        rangeLabel: this.formatRangeLabel(),
        loading: this.loading,
        totalHours: this.formatHours(totalMinutes),
        totalDays: String(totalDays),
        totalMoves: this.formatNumber(this.totalMoves),
        daily: this.daily,
        changeGroups: this.changeGroups
      };
    },

    onShow: function () {
      this.fetch();
    },

    onDestroy: function () {
      this.destroyChart();
    },

    destroyChart: function () {
      if (this.chart) {
        try { this.chart.destroy(); } catch (e) { /* noop */ }
        this.chart = null;
      }
    },

    fetch: function () {
      var that = this;
      var fromMs = this.from.valueOf();
      var toMs = this.to.valueOf();

      var dailyP = App.request('workActivity:user-daily',
        this.userpidSecId, fromMs, toMs);
      var changesP = App.request('workActivity:user-status-changes',
        this.userpidSecId, fromMs, toMs);

      $.when(dailyP, changesP).done(function (daily, changes) {
        that.loading = false;
        that.daily = that.prepareDaily(daily);
        that.changeGroups = that.prepareChangeGroups(changes);
        that.totalMoves = _.reduce(changes, function (a, c) {
          return a + (c.count || 0);
        }, 0);
        that.destroyChart();
        that.render();
        that.drawChart();
      });
    },

    prepareDaily: function (daily) {
      return _.map(daily, function (d) {
        return _.extend({}, d, {
          dayLabel: moment(d.day).format('ddd YYYY-MM-DD'),
          hours: (d.totalMinutes / 60).toFixed(2),
          firstSeenLabel: d.firstSeen ?
            moment(d.firstSeen).format('HH:mm') : '—',
          lastSeenLabel: d.lastSeen ?
            moment(d.lastSeen).format('HH:mm') : '—'
        });
      });
    },

    prepareChangeGroups: function (changes) {
      var grouped = _.groupBy(changes, 'commandType');
      return _.map(grouped, function (items, cmdType) {
        var total = _.reduce(items, function (a, c) {
          return a + (c.count || 0);
        }, 0);
        return {
          commandType: cmdType,
          total: total,
          items: items
        };
      });
    },

    drawChart: function () {
      if (!this.daily || this.daily.length === 0) { return; }
      var canvas = this.$('.js-daily-chart')[0];
      if (!canvas) { return; }

      var labels = _.map(this.daily, function (d) {
        return moment(d.day).format('MM-DD');
      });
      var values = _.map(this.daily, function (d) {
        return Math.round((d.totalMinutes / 60) * 10) / 10;
      });

      var ctx = canvas.getContext('2d');
      this.chart = new Chart(ctx).Bar({
        labels: labels,
        datasets: [{
          fillColor: 'rgba(66, 133, 244, 0.55)',
          strokeColor: 'rgba(66, 133, 244, 1)',
          highlightFill: 'rgba(66, 133, 244, 0.75)',
          highlightStroke: 'rgba(66, 133, 244, 1)',
          data: values
        }]
      }, {
        responsive: true,
        maintainAspectRatio: false,
        scaleBeginAtZero: true,
        scaleShowGridLines: true,
        barShowStroke: true,
        barStrokeWidth: 1,
        tooltipTemplate: '<%=value%> h'
      });
    },

    formatRangeLabel: function () {
      if (!this.from || !this.to) { return ''; }
      return this.from.format('YYYY-MM-DD') + '  →  ' +
             this.to.format('YYYY-MM-DD');
    },

    formatHours: function (totalMinutes) {
      if (!totalMinutes) { return '0h'; }
      var h = Math.floor(totalMinutes / 60);
      var m = totalMinutes % 60;
      if (h === 0) { return m + 'm'; }
      if (m === 0) { return h + 'h'; }
      return h + 'h ' + (m < 10 ? '0' + m : m) + 'm';
    },

    formatNumber: function (n) {
      if (n === null || n === undefined) { return '0'; }
      return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    onClose: function () {
      if (this.windowView) {
        this.windowView.close();
      }
    }
  });
});

